module.exports = __webpack_public_path__ + "img/mobile-gear-2-high.172296aa.png";